import classes from "./Title.module.css";

interface Props {
  title: string;
  dataAgentTarget?: string;
}

const Title = ({ title, dataAgentTarget = "" }: Props): JSX.Element => (
  <div data-agent-target={dataAgentTarget} className={classes.title}>
    {title}
  </div>
);

export default Title;
